// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInOverlayStyles } from "@rpsc/Overrides/Pages/SignInOverlay";
import { styledScrollbar } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

signInOverlayStyles.page = {
    css: css`
        &:empty {
            display: none;
        }
    `,
};

signInOverlayStyles.innerWrapper = {
    css: css`
        ${({ isEdit }: any) =>
            !isEdit &&
            css`
                padding: 0 13px 0 16px;
            `}
    `,
};

signInOverlayStyles.drawer = {
    mergeCss: true,  
    cssOverrides: {
        drawerTitle: css`
            padding: 13px 13px 10px 16px;
        `,
        drawerContent: css`
            ${styledScrollbar()}
        `,
        drawerBody: css`
            scrollbar-gutter: unset;
            padding-right: 3px;
        `
    },
};
